export class Player {
    constructor(name, rounds, isShortGame) {
        this.totalScore = 40;
        this.rounds = [];
        this.history = [];
        this.name = name;
        if (isShortGame) {
            this.totalScore = 0;
        }
        for (const round of rounds) {
            this.rounds.push(new Round(round, 0, 0));
        }
    }
}
export class Round {
    constructor(round, scoreInRound, totalAfterRound) {
        this.round = round;
        this.scoreInRound = scoreInRound;
        this.totalAfterRound = totalAfterRound;
    }
}
